import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuthProviderContext } from "../../Providers/AuthProvider";
import Breadcrumbs from "../../Components/Breadcrumbs";
import { usageInfo } from "../../services/user";
import { fnAddUserToDrip } from "../../utils/global";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const Help = () => {
  const navigate = useNavigate();
  const { auth, setAuth } = useAuthProviderContext();
  const [showUpgrade, setShowUpgrade] = useState(true);

  useEffect(() => {
    console.log(auth.user);
    if (auth.user) {
      try {
        (async () => {
          const res = await usageInfo();
          console.log(res);
          if (res.status == 200) {
            if (res.data.expired && showUpgrade) {
              fnAddUserToDrip();
              confirmAlert({
                title: "",
                message:
                  "You have exhausted your credits. Please upgrade your plan now",
                buttons: [
                  {
                    label: "Pay Now",
                    onClick: async () => {
                      navigate("/payment");
                    },
                  },
                  {
                    label: "Cancel",
                    onClick: () => {},
                  },
                ],
              });
            } else if (res.data.expiringSoon && showUpgrade) {
              confirmAlert({
                title: "",
                message:
                  "Your credits are going to be finished. Please upgrade your plan now",
                buttons: [
                  {
                    label: "Pay Now",
                    onClick: async () => {
                      navigate("/payment");
                    },
                  },
                  {
                    label: "Cancel",
                    onClick: () => {},
                  },
                ],
              });
            }
            setShowUpgrade(false);
          }
        })();
      } catch (error) {
        console.log(error);
      }
    }
  }, []);

  return (
    <React.Fragment>
      <div className="bg-white">
        <Breadcrumbs pageTitle="Help" title="Support" />
      </div>
      <div className="bg-greyColor3 py-6 px-6 md:py-11 md:px-14">
        <div className="max-w-[800px]">
          <p>
            Send your queries to{" "}
            <Link to="mailto:michael@outreachai.co" className="text-primary">
              michael@outreachai.co
            </Link>
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Help;
